import { render, staticRenderFns } from "./AlvoradaExamesIntraOperatorios.vue?vue&type=template&id=b4dbbb3a&scoped=true"
import script from "./AlvoradaExamesIntraOperatorios.vue?vue&type=script&lang=ts"
export * from "./AlvoradaExamesIntraOperatorios.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaExamesIntraOperatorios.vue?vue&type=style&index=0&id=b4dbbb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dbbb3a",
  null
  
)

export default component.exports